import { useMemo } from 'react';

import {
  SUGGESTED_ANSWER_EXAMPLE,
  SUGGESTED_ANSWER_FIXED,
  SUGGESTED_ANSWER_VARY,
} from 'global/constants';
import { PStyled } from 'approot/shared/styles/typography.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { ComponentFillInBlanks } from 'approot/activity-builder/components/component.constants';
import { getRichtextAnswer } from 'approot/activity-builder/components/shared/logic/get-richtext-answer';
import { isRichtextValueEmpty } from 'approot/activity-builder/components/shared/logic/get-richtext-value';
import SuggestedAnswerViewBadges from '../suggested-answer-view-badges';
import SuggestedAnswerTitle from '../../suggested-answer-title';
import SuggestedAnswerFillInBlanksViewFields from './suggested-answer-fill-in-blanks-view-fields';

type Props = {
  component: ComponentFillInBlanks;
  isUnitQuiz: boolean;
};

const SuggestedAnswerFillInBlanksView = ({ component, isUnitQuiz }: Props) => {
  const { suggestedAnswerProperties, subActivityProperties } = component;
  const answerType = suggestedAnswerProperties?.suggestedAnswerType;
  const isAnswersMayVary = answerType === SUGGESTED_ANSWER_VARY;

  const canDisplaySection = useMemo(() => {
    if (isAnswersMayVary) {
      return true;
    }

    if (
      !suggestedAnswerProperties?.suggestedAnswers ||
      suggestedAnswerProperties.suggestedAnswers.length === 0
    ) {
      return false;
    }

    return suggestedAnswerProperties.suggestedAnswers.some(
      suggestedData => !isRichtextValueEmpty(getRichtextAnswer(suggestedData))
    );
  }, [isAnswersMayVary, suggestedAnswerProperties]);

  return !canDisplaySection && !isUnitQuiz ? null : (
    <Box>
      <SuggestedAnswerTitle
        isSmall
        label={subActivityProperties?.subActivityLabel}
        instructions={subActivityProperties?.instructions}
      />

      <SuggestedAnswerViewBadges
        isExampleAnswer={
          answerType === SUGGESTED_ANSWER_EXAMPLE && canDisplaySection
        }
        isFixedAnswer={
          answerType === SUGGESTED_ANSWER_FIXED && canDisplaySection
        }
        suggestedAnswerScore={suggestedAnswerProperties?.suggestedAnswersScore}
        isUnitQuiz={isUnitQuiz}
      />

      {answerType === SUGGESTED_ANSWER_VARY ? (
        <PStyled>Answers may vary</PStyled>
      ) : canDisplaySection ? (
        <SuggestedAnswerFillInBlanksViewFields {...component} />
      ) : null}
    </Box>
  );
};

export default SuggestedAnswerFillInBlanksView;
